import { Component, EventEmitter, Input, Output } from '@angular/core';
import { findAndReplaceURL } from 'utils/helpers';
import { PublicRegistry } from 'services/organization/organization.interface';

@Component({
  selector: 'cm-public-block-element',
  templateUrl: './public-registry-block-element.component.html',
  styleUrls: ['./public-registry-block-element.component.scss'],
})
export class PublicRegistryBlockElementComponent {
  _entry: PublicRegistry.RegistryEntry;
  @Input() set entry(data: PublicRegistry.RegistryEntry) {
    const rows = data.rows.map(row => ({
      ...row,
      value: findAndReplaceURL(row.value || 'N/A', row.url),
    }));
    this._entry = {
      ...data,
      rows,
    };
  }
  @Input() recordView = false;
  @Input() ignoreHideFilter = false;
  @Input() hideDetailsBtn = false;

  @Output() viewDetailsClick = new EventEmitter();
}
